const LobbyActionTypes = {
    SET_ALL_CERTIFIED_TEAMMATE_IDS: "SET_ALL_CERTIFIED_TEAMMATE_IDS",
    SET_CAPTAIN_VOTE_IDS: "SET_CAPTAIN_VOTE_IDS",
    SET_TEAM_STATE: "SET_TEAM_STATE",
};

export default LobbyActionTypes;